import React, { FC, useEffect } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { getWeatherIcon } from "./weatherIcon";
import { storage } from "../../firebase/firebase";
import { ref, getDownloadURL } from "firebase/storage";
import "../../index.css";

const root = css`
  padding: 4px;
  text-align: center;
`;
const tempText = css`
  margin: 0;
  font-size: 12px;
  padding-top: 4px;
`;

const weatherIcon = css`
  zoom: 0.25;
  display: inline-block;
  position: relative;
  width: 150px;
  height: 80px;
  overflow: hidden;
  pointer-events: none;
`;

const WeatherInfo: FC<{
  isBlank?: boolean;
  weatherCode: string;
  maxTemp: string;
  minTemp: string;
}> = ({ isBlank = false, weatherCode, maxTemp, minTemp }) => {
  const [iconNo, setIconNo] = React.useState("000");
  const [imageUrl, setImageUrl] = React.useState("");
  const [blankImageUrl, setBlankImageUrl] = React.useState("");

  useEffect(() => {
    // 仕様: Firebase Storageから天気アイコンのスプライト画像を取得
    // エラー時はローカルの静的ファイルにフォールバック
    const imageRef = ref(storage, "image/1000.webp");
    getDownloadURL(imageRef)
      .then((url) => {
        setImageUrl(url);
      })
      .catch((error) => {
        console.error("Error getting image URL from Firebase Storage:", error);
        // フォールバック: ローカルの静的画像を使用
        setImageUrl(`${window.location.origin}/image/1000.webp`);
      });

    const blankImageRef = ref(storage, "image/blank.png");
    getDownloadURL(blankImageRef)
      .then((url) => {
        setBlankImageUrl(url);
      })
      .catch((error) => {
        console.error("Error getting blank image URL from Firebase Storage:", error);
        // フォールバック: ローカルの静的画像を使用
        setBlankImageUrl(`${window.location.origin}/image/blank.png`);
      });
  }, []);

  useEffect(() => {
    setIconNo(weatherCode ? getWeatherIcon(weatherCode) : "000");
  }, [weatherCode]);

  if (!weatherCode && !maxTemp && !minTemp) {
    return (
      <div css={root}>
        <a href="#" css={weatherIcon}>
          <img src={blankImageUrl} alt={""} />
        </a>
        <p css={tempText}>&nbsp;</p>
      </div>
    );
  }

  return isBlank ? (
    <div css={root}>
      <a href="#" css={weatherIcon}>
        <img src={blankImageUrl} alt={""} />
      </a>
      <p css={tempText}>- / -</p>
    </div>
  ) : (
    <div css={root}>
      <a href="#" css={weatherIcon}>
        <img src={imageUrl} className={"item" + iconNo} alt={""} />
      </a>
      <p css={tempText}>
        <span style={{ color: "red" }}>{maxTemp}</span>
        <span> / </span>
        <span style={{ color: "blue" }}>{minTemp}</span>
      </p>
    </div>
  );
};

export default WeatherInfo;
